import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"


import { SearchX } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false
},
  __name: 'SearchNotFoundIcon',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SearchX), { class: "w-16 h-16 mx-auto mb-4 text-gray-400" }))
}
}

})